// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rgAxl{margin-bottom:20px}.J2Aa3{display:flex;width:fit-content;align-items:center;justify-content:space-between}.nbsos{padding:16px;display:flex;align-items:center;justify-content:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bundleTable": `rgAxl`,
	"bundleHeader": `J2Aa3`,
	"noServices": `nbsos`
};
export default ___CSS_LOADER_EXPORT___;
